import { render, staticRenderFns } from "./CustomMessageFields.vue?vue&type=template&id=7c0b721c&scoped=true"
import script from "./CustomMessageFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMessageFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomMessageFields.vue?vue&type=style&index=0&id=7c0b721c&prod&lang=scss&scoped=true"
import style1 from "./CustomMessageFields.vue?vue&type=style&index=1&id=7c0b721c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b721c",
  null
  
)

export default component.exports